import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "formulario",
  class: "bg-gray-100 py-12"
}
const _hoisted_2 = { class: "container mx-auto px-4 max-w-7xl" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "font-bold text-gray-800 mb-4" }, "Por favor complete el formulario en su totalidad", -1)
const _hoisted_4 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0" }
const _hoisted_5 = { class: "w-full px-2 md:w-1/5" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "DNI / Pasaporte", -1)
const _hoisted_7 = { class: "text-sm text-red-500 p-error" }
const _hoisted_8 = { class: "w-full px-2 md:w-2/5" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "Nombre", -1)
const _hoisted_10 = { class: "text-sm text-red-500 p-error" }
const _hoisted_11 = { class: "w-full px-2 md:w-2/5" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "Apellido", -1)
const _hoisted_13 = { class: "text-sm text-red-500 p-error" }
const _hoisted_14 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_15 = { class: "w-full px-2 md:w-2/5" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "Empresa / Profesional", -1)
const _hoisted_17 = { class: "text-sm text-red-500 p-error" }
const _hoisted_18 = { class: "w-full px-2 md:w-1/5" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "CUIT / Matrícula", -1)
const _hoisted_20 = { class: "text-sm text-red-500 p-error" }
const _hoisted_21 = { class: "w-full px-2 md:w-2/5" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "Cargo", -1)
const _hoisted_23 = { class: "text-sm text-red-500 p-error" }
const _hoisted_24 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_25 = { class: "w-full px-2 md:w-1/3" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "Mail", -1)
const _hoisted_27 = { class: "text-sm text-red-500 p-error" }
const _hoisted_28 = { class: "w-full px-2 md:w-1/3" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "Sitio web (corporativo)", -1)
const _hoisted_30 = { class: "text-sm text-red-500 p-error" }
const _hoisted_31 = { class: "w-full px-2 md:w-1/3" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "Instragram / Facebook", -1)
const _hoisted_33 = { class: "text-sm text-red-500 p-error" }
const _hoisted_34 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_35 = { class: "w-full px-2 md:w-3/12" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "País", -1)
const _hoisted_37 = { class: "w-full px-2 md:w-2/12" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "Código de país", -1)
const _hoisted_39 = { class: "w-full px-2 md:w-3/12" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "Teléfono comercial", -1)
const _hoisted_41 = { class: "text-sm text-red-500 p-error" }
const _hoisted_42 = { class: "w-full px-2 md:w-4/12" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "Teléfono celular", -1)
const _hoisted_44 = { class: "text-sm text-red-500 p-error" }
const _hoisted_45 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_46 = { class: "w-full px-2 md:w-1/3" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "Provincia", -1)
const _hoisted_48 = { class: "text-sm text-red-500 p-error" }
const _hoisted_49 = { class: "w-full px-2 md:w-2/3" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "Domicilio comercial", -1)
const _hoisted_51 = { class: "text-sm text-red-500 p-error" }
const _hoisted_52 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_53 = { class: "w-full px-2 md:w-1/2" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "Rubro", -1)
const _hoisted_55 = { class: "text-sm text-red-500 p-error" }
const _hoisted_56 = { class: "w-full px-2 md:w-1/2" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "¿Cómo conoció FIMAR?", -1)
const _hoisted_58 = { class: "text-sm text-red-500 p-error" }
const _hoisted_59 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_60 = { class: "w-full px-2 md:w-1/2" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "¿Que expo viene a visitar?", -1)
const _hoisted_62 = { class: "text-sm text-red-500 p-error" }
const _hoisted_63 = { class: "w-full px-2 md:w-1/2" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "¿Visitará el Salón del Mueble Argentino?", -1)
const _hoisted_65 = { class: "text-sm text-red-500 p-error" }
const _hoisted_66 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_67 = { class: "w-full px-2" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "¿A qué expositor viene a vistar en la expo?", -1)
const _hoisted_69 = { class: "text-sm text-red-500 p-error" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("h1", { class: "font-bold text-gray-800 mb-4 md:mt-5" }, "Algunos datos sobre su comercio", -1)
const _hoisted_71 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_72 = { class: "w-full px-2 md:w-1/4" }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "¿Tiene showroom?", -1)
const _hoisted_74 = { class: "text-sm text-red-500 p-error" }
const _hoisted_75 = { class: "w-full px-2 md:w-1/4" }
const _hoisted_76 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "¿Vende por e-commerce?", -1)
const _hoisted_77 = { class: "text-sm text-red-500 p-error" }
const _hoisted_78 = { class: "w-full px-2 md:w-1/4" }
const _hoisted_79 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "¿Tiene sucursales?", -1)
const _hoisted_80 = { class: "text-sm text-red-500 p-error" }
const _hoisted_81 = { class: "w-full px-2 md:w-1/4" }
const _hoisted_82 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "¿Pertenece a una red u organización?", -1)
const _hoisted_83 = { class: "text-sm text-red-500 p-error" }
const _hoisted_84 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_85 = { class: "w-full px-2 md:w-1/2" }
const _hoisted_86 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "Especifique cuantas sucursales tiene", -1)
const _hoisted_87 = { class: "text-sm text-red-500 p-error" }
const _hoisted_88 = { class: "w-full px-2 md:w-1/2" }
const _hoisted_89 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "¿Cuál es el nombre de la organización a la que pertenece?", -1)
const _hoisted_90 = { class: "text-sm text-red-500 p-error" }
const _hoisted_91 = { class: "flex flex-wrap py-2 mt-3" }
const _hoisted_92 = ["disabled"]
const _hoisted_93 = { class: "pi pi-spin pi-spinner mr-2" }
const _hoisted_94 = { class: "pi pi-check mr-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Field = _resolveComponent("Field")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_Form, {
      onSubmit: _ctx.onSubmit,
      "validation-schema": _ctx.schema,
      class: "space-y-4 text-gray-700"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createVNode(_component_Field, {
                name: "dni",
                modelValue: _ctx.formData.dni,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.dni) = $event))
              }, {
                default: _withCtx(({ field }) => [
                  _createVNode(_component_InputText, _mergeProps(field, {
                    type: "text",
                    class: "w-full p-inputtext-sm p-3",
                    placeholder: "DNI / Pasaporte"
                  }), null, 16),
                  _createElementVNode("span", _hoisted_7, [
                    _createVNode(_component_ErrorMessage, { name: "dni" })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createVNode(_component_Field, {
                name: "nombre",
                modelValue: _ctx.formData.nombre,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.nombre) = $event))
              }, {
                default: _withCtx(({ field }) => [
                  _createVNode(_component_InputText, _mergeProps(field, {
                    type: "text",
                    class: "w-full p-inputtext-sm p-3",
                    placeholder: "Nombre"
                  }), null, 16),
                  _createElementVNode("span", _hoisted_10, [
                    _createVNode(_component_ErrorMessage, { name: "nombre" })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createVNode(_component_Field, {
                name: "apellido",
                modelValue: _ctx.formData.apellido,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.apellido) = $event))
              }, {
                default: _withCtx(({ field }) => [
                  _createVNode(_component_InputText, _mergeProps(field, {
                    type: "text",
                    class: "w-full p-inputtext-sm p-3",
                    placeholder: "Apellido"
                  }), null, 16),
                  _createElementVNode("span", _hoisted_13, [
                    _createVNode(_component_ErrorMessage, { name: "apellido" })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _createVNode(_component_Field, {
                name: "empresa",
                modelValue: _ctx.formData.empresa,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.empresa) = $event))
              }, {
                default: _withCtx(({ field }) => [
                  _createVNode(_component_InputText, _mergeProps(field, {
                    type: "text",
                    class: "w-full p-inputtext-sm p-3",
                    placeholder: "Empresa"
                  }), null, 16),
                  _createElementVNode("span", _hoisted_17, [
                    _createVNode(_component_ErrorMessage, { name: "empresa" })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _hoisted_19,
              _createVNode(_component_Field, {
                name: "cuit",
                modelValue: _ctx.formData.cuit,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.cuit) = $event))
              }, {
                default: _withCtx(({ field }) => [
                  _createVNode(_component_InputText, _mergeProps(field, {
                    type: "text",
                    class: "w-full p-inputtext-sm p-3",
                    placeholder: "CUIT / Matrícula"
                  }), null, 16),
                  _createElementVNode("span", _hoisted_20, [
                    _createVNode(_component_ErrorMessage, { name: "cuit" })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              _createVNode(_component_Field, {
                name: "cargo",
                modelValue: _ctx.formData.cargo,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.cargo) = $event))
              }, {
                default: _withCtx(({ handleChange, handleBlur, value }) => [
                  _createVNode(_component_Dropdown, {
                    onBlur: handleBlur,
                    "onUpdate:modelValue": handleChange,
                    "model-value": value,
                    placeholder: "Seleccione el cargo",
                    class: "w-full md:w-14rem p-inputtext-sm",
                    options: _ctx.cargos,
                    optionLabel: "descripcion"
                  }, null, 8, ["onBlur", "onUpdate:modelValue", "model-value", "options"]),
                  _createElementVNode("span", _hoisted_23, [
                    _createVNode(_component_ErrorMessage, { name: "cargo" })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _hoisted_26,
              _createVNode(_component_Field, {
                name: "mail",
                modelValue: _ctx.formData.mail,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.mail) = $event))
              }, {
                default: _withCtx(({ field }) => [
                  _createVNode(_component_InputText, _mergeProps(field, {
                    type: "mail",
                    class: "w-full p-inputtext-sm p-3"
                  }), null, 16),
                  _createElementVNode("span", _hoisted_27, [
                    _createVNode(_component_ErrorMessage, { name: "mail" })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_28, [
              _hoisted_29,
              _createVNode(_component_Field, {
                name: "website",
                modelValue: _ctx.formData.website,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.website) = $event))
              }, {
                default: _withCtx(({ field }) => [
                  _createVNode(_component_InputText, _mergeProps(field, {
                    type: "text",
                    class: "w-full p-inputtext-sm p-3",
                    placeholder: "Sitio web"
                  }), null, 16),
                  _createElementVNode("span", _hoisted_30, [
                    _createVNode(_component_ErrorMessage, { name: "website" })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_31, [
              _hoisted_32,
              _createVNode(_component_Field, {
                name: "instagramFacebook",
                modelValue: _ctx.formData.instagramFacebook,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.instagramFacebook) = $event))
              }, {
                default: _withCtx(({ field }) => [
                  _createVNode(_component_InputText, _mergeProps(field, {
                    type: "text",
                    class: "w-full p-inputtext-sm p-3",
                    placeholder: "Instragram / Facebook"
                  }), null, 16),
                  _createElementVNode("span", _hoisted_33, [
                    _createVNode(_component_ErrorMessage, { name: "instagramFacebook" })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _hoisted_36,
              _createVNode(_component_Dropdown, {
                modelValue: _ctx.selectedCountry,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.selectedCountry) = $event)),
                filter: "",
                options: _ctx.paises,
                optionLabel: "value",
                placeholder: "Select a Country",
                class: "w-full md:w-14rem p-inputtext-sm"
              }, null, 8, ["modelValue", "options"])
            ]),
            _createElementVNode("div", _hoisted_37, [
              _hoisted_38,
              (_ctx.selectedCountry !== null)
                ? (_openBlock(), _createBlock(_component_InputText, {
                    key: 0,
                    type: "text",
                    modelValue: _ctx.selectedCountry.code,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.selectedCountry.code) = $event)),
                    class: "w-full p-inputtext-sm p-3",
                    readonly: ""
                  }, null, 8, ["modelValue"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_39, [
              _hoisted_40,
              _createVNode(_component_Field, {
                name: "telefonoComercial",
                modelValue: _ctx.formData.telefonoComercial,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.telefonoComercial) = $event))
              }, {
                default: _withCtx(({ field }) => [
                  _createVNode(_component_InputText, _mergeProps(field, {
                    type: "text",
                    class: "w-full p-inputtext-sm p-3"
                  }), null, 16),
                  _createElementVNode("span", _hoisted_41, [
                    _createVNode(_component_ErrorMessage, { name: "telefonoComercial" })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_42, [
              _hoisted_43,
              _createVNode(_component_Field, {
                name: "telefonoCelular",
                modelValue: _ctx.formData.telefonoCelular,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formData.telefonoCelular) = $event))
              }, {
                default: _withCtx(({ field }) => [
                  _createVNode(_component_InputText, _mergeProps(field, {
                    type: "text",
                    class: "w-full p-inputtext-sm p-3"
                  }), null, 16),
                  _createElementVNode("span", _hoisted_44, [
                    _createVNode(_component_ErrorMessage, { name: "telefonoCelular" })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("div", _hoisted_46, [
              _hoisted_47,
              _createVNode(_component_Field, {
                name: "provincia",
                modelValue: _ctx.formData.provincia,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formData.provincia) = $event))
              }, {
                default: _withCtx(({ field }) => [
                  _createVNode(_component_InputText, _mergeProps(field, {
                    type: "text",
                    class: "w-full p-inputtext-sm p-3",
                    placeholder: "Provincia"
                  }), null, 16),
                  _createElementVNode("span", _hoisted_48, [
                    _createVNode(_component_ErrorMessage, { name: "provincia" })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_49, [
              _hoisted_50,
              _createVNode(_component_Field, {
                name: "domicilioComercial",
                modelValue: _ctx.formData.domicilioComercial,
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formData.domicilioComercial) = $event))
              }, {
                default: _withCtx(({ field }) => [
                  _createVNode(_component_InputText, _mergeProps(field, {
                    type: "text",
                    class: "w-full p-inputtext-sm p-3",
                    placeholder: "Domicilio comercial"
                  }), null, 16),
                  _createElementVNode("span", _hoisted_51, [
                    _createVNode(_component_ErrorMessage, { name: "domicilioComercial" })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_52, [
            _createElementVNode("div", _hoisted_53, [
              _hoisted_54,
              _createVNode(_component_Field, {
                name: "rubro",
                modelValue: _ctx.formData.rubro,
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.formData.rubro) = $event))
              }, {
                default: _withCtx(({ handleChange, handleBlur, value }) => [
                  _createVNode(_component_Dropdown, {
                    onBlur: handleBlur,
                    "onUpdate:modelValue": handleChange,
                    "model-value": value,
                    placeholder: "Seleccione el rubro",
                    class: "w-full md:w-14rem p-inputtext-sm",
                    options: _ctx.rubros,
                    optionLabel: "descripcion"
                  }, null, 8, ["onBlur", "onUpdate:modelValue", "model-value", "options"]),
                  _createElementVNode("span", _hoisted_55, [
                    _createVNode(_component_ErrorMessage, { name: "rubro" })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_56, [
              _hoisted_57,
              _createVNode(_component_Field, {
                name: "tipoContacto",
                modelValue: _ctx.formData.tipoContacto,
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.formData.tipoContacto) = $event))
              }, {
                default: _withCtx(({ handleChange, handleBlur, value }) => [
                  _createVNode(_component_Dropdown, {
                    onBlur: handleBlur,
                    "onUpdate:modelValue": handleChange,
                    "model-value": value,
                    placeholder: "Seleccione como nos conoció",
                    class: "w-full md:w-14rem p-inputtext-sm",
                    options: _ctx.tiposContactos,
                    optionLabel: "descripcion"
                  }, null, 8, ["onBlur", "onUpdate:modelValue", "model-value", "options"]),
                  _createElementVNode("span", _hoisted_58, [
                    _createVNode(_component_ErrorMessage, { name: "tipoContacto" })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_59, [
            _createElementVNode("div", _hoisted_60, [
              _hoisted_61,
              _createVNode(_component_Field, {
                name: "expoVisita",
                modelValue: _ctx.formData.expoVisita,
                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.formData.expoVisita) = $event))
              }, {
                default: _withCtx(({ handleChange, handleBlur, value }) => [
                  _createVNode(_component_Dropdown, {
                    onBlur: handleBlur,
                    "onUpdate:modelValue": handleChange,
                    "model-value": value,
                    placeholder: "Seleccione la expo que viene a visitar",
                    class: "w-full md:w-14rem p-inputtext-sm",
                    options: _ctx.expos,
                    optionLabel: "descripcion"
                  }, null, 8, ["onBlur", "onUpdate:modelValue", "model-value", "options"]),
                  _createElementVNode("span", _hoisted_62, [
                    _createVNode(_component_ErrorMessage, { name: "expoVisita" })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_63, [
              _hoisted_64,
              _createVNode(_component_Field, {
                name: "visitaSalonMueble",
                modelValue: _ctx.formData.visitaSalonMueble,
                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.formData.visitaSalonMueble) = $event))
              }, {
                default: _withCtx(({ handleChange, handleBlur, value }) => [
                  _createVNode(_component_Dropdown, {
                    onBlur: handleBlur,
                    "onUpdate:modelValue": handleChange,
                    "model-value": value,
                    placeholder: "Seleccione si visita el salón del mueble",
                    class: "w-full md:w-14rem p-inputtext-sm",
                    options: _ctx.siNo,
                    optionLabel: "descripcion"
                  }, null, 8, ["onBlur", "onUpdate:modelValue", "model-value", "options"]),
                  _createElementVNode("span", _hoisted_65, [
                    _createVNode(_component_ErrorMessage, { name: "visitaSalonMueble" })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_66, [
            _createElementVNode("div", _hoisted_67, [
              _hoisted_68,
              _createVNode(_component_Field, {
                name: "expositorVisita",
                modelValue: _ctx.formData.expositorVisita,
                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.formData.expositorVisita) = $event))
              }, {
                default: _withCtx(({ field }) => [
                  _createVNode(_component_InputText, _mergeProps(field, {
                    type: "text",
                    class: "w-full p-inputtext-sm p-3",
                    placeholder: "Ingrese a que expositor viene a visitar"
                  }), null, 16),
                  _createElementVNode("span", _hoisted_69, [
                    _createVNode(_component_ErrorMessage, { name: "expositorVisita" })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _hoisted_70,
          _createElementVNode("div", _hoisted_71, [
            _createElementVNode("div", _hoisted_72, [
              _hoisted_73,
              _createVNode(_component_Field, {
                name: "tieneShowroom",
                modelValue: _ctx.formData.tieneShowroom,
                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.formData.tieneShowroom) = $event))
              }, {
                default: _withCtx(({ handleChange, handleBlur, value }) => [
                  _createVNode(_component_Dropdown, {
                    onBlur: handleBlur,
                    "onUpdate:modelValue": handleChange,
                    "model-value": value,
                    placeholder: "Seleccione una opción",
                    class: "w-full md:w-14rem p-inputtext-sm",
                    options: _ctx.siNo,
                    optionLabel: "descripcion"
                  }, null, 8, ["onBlur", "onUpdate:modelValue", "model-value", "options"]),
                  _createElementVNode("span", _hoisted_74, [
                    _createVNode(_component_ErrorMessage, { name: "tieneShowroom" })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_75, [
              _hoisted_76,
              _createVNode(_component_Field, {
                name: "vendePorEcommerce",
                modelValue: _ctx.formData.vendePorEcommerce,
                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.formData.vendePorEcommerce) = $event))
              }, {
                default: _withCtx(({ handleChange, handleBlur, value }) => [
                  _createVNode(_component_Dropdown, {
                    onBlur: handleBlur,
                    "onUpdate:modelValue": handleChange,
                    "model-value": value,
                    placeholder: "Seleccione una opción",
                    class: "w-full md:w-14rem p-inputtext-sm",
                    options: _ctx.siNo,
                    optionLabel: "descripcion"
                  }, null, 8, ["onBlur", "onUpdate:modelValue", "model-value", "options"]),
                  _createElementVNode("span", _hoisted_77, [
                    _createVNode(_component_ErrorMessage, { name: "vendePorEcommerce" })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_78, [
              _hoisted_79,
              _createVNode(_component_Field, {
                name: "tieneSucursales",
                modelValue: _ctx.formData.tieneSucursales,
                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.formData.tieneSucursales) = $event))
              }, {
                default: _withCtx(({ handleChange, handleBlur, value }) => [
                  _createVNode(_component_Dropdown, {
                    onBlur: handleBlur,
                    "onUpdate:modelValue": handleChange,
                    "model-value": value,
                    placeholder: "Seleccione una opción",
                    class: "w-full md:w-14rem p-inputtext-sm",
                    options: _ctx.siNo,
                    optionLabel: "descripcion"
                  }, null, 8, ["onBlur", "onUpdate:modelValue", "model-value", "options"]),
                  _createElementVNode("span", _hoisted_80, [
                    _createVNode(_component_ErrorMessage, { name: "tieneSucursales" })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_81, [
              _hoisted_82,
              _createVNode(_component_Field, {
                name: "perteneceRed",
                modelValue: _ctx.formData.perteneceRed,
                "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.formData.perteneceRed) = $event))
              }, {
                default: _withCtx(({ handleChange, handleBlur, value }) => [
                  _createVNode(_component_Dropdown, {
                    onBlur: handleBlur,
                    "onUpdate:modelValue": handleChange,
                    "model-value": value,
                    placeholder: "Seleccione una opción",
                    class: "w-full md:w-14rem p-inputtext-sm",
                    options: _ctx.siNo,
                    optionLabel: "descripcion"
                  }, null, 8, ["onBlur", "onUpdate:modelValue", "model-value", "options"]),
                  _createElementVNode("span", _hoisted_83, [
                    _createVNode(_component_ErrorMessage, { name: "perteneceRed" })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_84, [
            _withDirectives(_createElementVNode("div", _hoisted_85, [
              _hoisted_86,
              _createVNode(_component_Field, {
                name: "cantidadSucursales",
                modelValue: _ctx.formData.cantidadSucursales,
                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.formData.cantidadSucursales) = $event))
              }, {
                default: _withCtx(({ field }) => [
                  _createVNode(_component_InputText, _mergeProps(field, {
                    type: "text",
                    class: "w-full p-inputtext-sm p-3"
                  }), null, 16),
                  _createElementVNode("span", _hoisted_87, [
                    _createVNode(_component_ErrorMessage, { name: "cantidadSucursales" })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ], 512), [
              [_vShow, _ctx.formData.tieneSucursales != undefined && _ctx.formData.tieneSucursales.id === 1]
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_88, [
              _hoisted_89,
              _createVNode(_component_Field, {
                name: "nombreRed",
                modelValue: _ctx.formData.nombreRed,
                "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.formData.nombreRed) = $event))
              }, {
                default: _withCtx(({ field }) => [
                  _createVNode(_component_InputText, _mergeProps(field, {
                    type: "text",
                    class: "w-full p-inputtext-sm p-3"
                  }), null, 16),
                  _createElementVNode("span", _hoisted_90, [
                    _createVNode(_component_ErrorMessage, { name: "nombreRed" })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ], 512), [
              [_vShow, _ctx.formData.perteneceRed != undefined && _ctx.formData.perteneceRed.id === 1]
            ])
          ]),
          _createElementVNode("div", _hoisted_91, [
            _createElementVNode("button", {
              type: "submit",
              label: "REGISTRARME",
              class: "mt-4 px-4 py-2 bg-transparent border-black hover:bg-black text-black font-semibold hover:text-white border rounded",
              disabled: _ctx.isSubmitting
            }, [
              _withDirectives(_createElementVNode("i", _hoisted_93, null, 512), [
                [_vShow, _ctx.isSubmitting]
              ]),
              _withDirectives(_createElementVNode("i", _hoisted_94, null, 512), [
                [_vShow, !_ctx.isSubmitting]
              ]),
              _createTextVNode("REGISTRARME ")
            ], 8, _hoisted_92)
          ])
        ])
      ]),
      _: 1
    }, 8, ["onSubmit", "validation-schema"])
  ]))
}